import type { TBgColor } from '@/components/_promo/templates/BanksBenefitsTemplate/styled';
import { ImageComponent } from '@/components/Image';
import { useMedia } from '@/hooks';
import { brandSizeMap, getBrandKey, paymentBrands } from './helpers';
import { ScBanksLogosListWrapper } from './styled';

const imgSrc = (src: string) => `/lp/banks-benefits/${src}.webp`;

interface IBanksLogosListProps {
  bgColor?: TBgColor;
}

export const BanksLogosList = ({ bgColor }: IBanksLogosListProps) => {
  const { isMobile } = useMedia();

  return (
    <ScBanksLogosListWrapper $bgColor={bgColor}>
      {paymentBrands.map((name) => (
        <div className="bank" key={name}>
          <ImageComponent
            alt={name}
            className="bank-img"
            fill={isMobile}
            src={imgSrc(name)}
            {...(!isMobile && {
              width: brandSizeMap[getBrandKey(name)].width,
              height: brandSizeMap[getBrandKey(name)].height,
            })}
          />
        </div>
      ))}
    </ScBanksLogosListWrapper>
  );
};
